<template>
<div class="all-detail-task">
    <div @mouseenter="hoverCurrent=index" @mouseleave="hoverCurrent=-1" class="progress-box-height" :class="[item.open?'progress-box-success':'',taskDatas.length>8?'progress-box-overflow':'progress-box']" v-for="(item, index) in taskDatas" :key="index" @click="collapse(index,item)">
        <div class="detailed-progress-box">
        </div>
        <div class="task-info">
            <div class="task-info-name">
                <div class="task-status-name status-green">{{$t('language.cloudTransfer.transferSucces')}}:</div>
                <div :title="item.sourceFilename" class="detailed-sources-name">&nbsp;{{item.sourceFilename}}</div>
            </div>
            <div class="task-info-percent"></div>
            <div class="task-info-speed" v-if="hoverCurrent==index">
                <div class="icon-util taskinfo-collapse-position" :class="item.open?'collapse-up':'collapse-down'"></div>
            </div>
            <successDetail :open=item.open :index=index :itemDetail='item'></successDetail>
        </div>
    </div>
</div>
</template>

<script>
import successDetail from '@/components/common/tabs/tabs_detailed_progress/tab_success_detail';
export default {

    components: {
        successDetail
    },
    data: function () {
        return {
            statusColor: "",
            clickCurrent: -1,
            hoverCurrent: -1,
            taskDatas: []
        };
    },
      watch:{
      '$store.state.detailTabSuccess':function(newValue,oldValue){
          this.taskDatas=newValue;
      }
    },
    methods: {
             collapse(index, item) {
            if (item.open) {
                item.open=false;
                this.$forceUpdate();
            } else {
               item.open=true;
               this.$forceUpdate();
               $.each(this.taskDatas,function(j,jItem){
                    if(item.taskId!=jItem.taskId&&jItem.open){
                        jItem.open=false;
                    }
               });
            }
        },
    }
};
</script>

<style>
.transfer-success-progress {
    width: 250px;/*no*/
    height: 100%;
    float: right;
}

.transfer-success-footer {
    font-size: 12px;/*no*/
    color: rgba(0, 0, 0, 0.6);
}


</style>



// WEBPACK FOOTER //
// src/components/common/tabs/tabs_detailed_progress/tab_successful_tasks.vue